export default __webpack_public_path__ + "static/media/comingsoon2.6bc2c852.png";